export default __webpack_public_path__ + "static/media/LondrinaSolid-Black.ec88da3c.ttf";